import type { ToastContentProps } from 'react-toastify';
import type { ZodError } from 'zod';

interface Props extends Partial<ToastContentProps> {
    zodError: ZodError<unknown>;
}

export default function ZodErrorToast({ zodError }: Props) {
    return (
        <div>
            {zodError.issues.map((issue) => (
                <code>
                    {issue.path.join('.')} {issue.message}
                </code>
            ))}
        </div>
    );
}
